import {FACTIONS} from "../../../constants/factions";

export const ENTS_QUOTES = [{
  quote: 'В родной роще сама земля бьёт вместо нас',
  author: 'Эркрад  Суковатый, энт-страж Глухой опушки',
  factionId: FACTIONS.ENTS
}, {
  quote: 'Лес не прощает тех, кто рубит ветки. Лес запоминает. И однажды прорастает сквозь их кости',
  author: 'Олдред Мшистобородый, энт-песнопевец Гулких крон',
  factionId: FACTIONS.ENTS
}, {
  quote: 'Враг, зашедший в рощу, уже не враг. Он — удобрение',
  author: 'Гронд Желуденосный, энт-прародитель Прорастающих троп',
  factionId: FACTIONS.ENTS
}, {
  quote: 'Лес не нападает. Лес просто возвращает себе то, что вы у него взяли',
  author: 'Ольгерд Ветвисторогий, старейшина энтов Смыкающихся крон',
  factionId: FACTIONS.ENTS
}, {
  quote: 'Сруби дерево. Посмотри, как оно падает. Через сто лет на этом месте вырастет новое. А ты уже сгнил',
  author: 'Лихорад Короедный, энт-хранитель Дубовой Сердцевины',
  factionId: FACTIONS.ENTS
}, {
  quote: 'Человек прожил жизнь и забыл. Дерево прожило жизнь и помнит. Мы — голос этой памяти. И она горькая',
  author: 'Фимбриль Толстокорая, энт-мать Опавших иглиц',
  factionId: FACTIONS.ENTS
}]